import React from 'react'

import styled from 'styled-components'

type BookBackdropProps = {
  bg?: string
}

const ColoredDialogBackdrop: React.FunctionComponent<BookBackdropProps> = ({ bg }) => (
  <Container>
    <Background bg={bg}/>
    <Tint />
  </Container>
)

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`

export const Tint = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0);
    opacity: 0.3;
`

export const Background = styled.div<{ bg?: string }>`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${p => p.bg};
    opacity: 0.95;
`


export default ColoredDialogBackdrop